var launchMiddleware = function (dispatch) { return function (next, done) { return function (message) {
    if (message.domain !== 'launch') {
        return next(message);
    }
    switch (message.eventType) {
        case 'iab':
            var _a = message.data.data, url = _a.url, settings = _a.settings;
            window.open(url, '_iab');
            done();
            break;
        // @TODO Need to dispatch an event back?
        default:
            console.warn('Unhandled launch domain event', message);
            return next(message);
    }
}; }; };
export default launchMiddleware;
//# sourceMappingURL=launch.js.map